import React, { useState, useEffect } from "react";

const ButtonGroup = ({
  buttons,
  onSelected = () => {},
  defaultSelected,
  label,
}) => {
  const [selected, setSelected] = useState(() => {
    return buttons.findIndex((btn) => btn.id === defaultSelected);
  });

  useEffect(() => {
    const selectedValue = buttons.findIndex((btn) => btn.id === defaultSelected);
    setSelected(selectedValue);
  }, [defaultSelected, buttons]);

  const handleClick = (e, index) => {
    e.preventDefault();
    setSelected(index);
    onSelected(buttons[index]);
  };

  return (
    <div className="max-w-96 ">
      <label className="block text-sm font-medium text-gray-500 dark:text-gray-400">{label}</label>
      <div
        className="grid rounded-md overflow-hidden mt-2"
        style={{ gridTemplateColumns: `repeat(${buttons.length}, 1fr)` }}
      >
        {buttons.map((btn, index, arr) => {
          const isSelected = selected === index;
          const isLast = arr.length - 1 === index;
          return (
            <button
              key={btn.id || index}
              onClick={(e) => handleClick(e, index)}
              className={`px-3 sm:px-4 py-2 ${
                isSelected
                  ? "bg-primary text-white"
                  : "bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 hover:bg-gray-300 dark:hover:bg-gray-600"
              } ${!isLast && "border-r border-slate-300 dark:border-slate-600"} focus:outline-none`}
            >
              <div>{btn.label}</div>
              <div
                className={`text-xs ${
                  isSelected ? "text-slate-100" : "text-slate-400 dark:text-slate-500"
                }`}
              >
                {btn.description}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ButtonGroup;
